import React from 'react'
import NameInfo from './NameInfo';
import {Tags} from './Tags';
import Answer from './Answer';
import QuestionBox from './QuestionBox';
import Styles from './styles.module.css';
import {Spin, Skeleton} from 'antd';

export default function index({data, question}) {
    const containerStyle = {
        border: "1px solid #E0E2E6",
        borderRadius: "16px",
        background: "#FFFFFF",
        boxShadow: "0px 4px 16px 0px #1018280F",
        padding: "24px 36px 24px 36px",
        minHeight: "100px",
        marginBottom:'24px'
      };
  //     console.log("question",question)

  // console.log(data,'cehck data')
  return (
    <>
    <div style={containerStyle}>
    <QuestionBox question={question}  />
        {!question.reusableThreadQA && <Tags data={question}  />}
        {data.length!==0 && data.map((answer,index)=>{
          return(
            <>
            <NameInfo data={answer} question={question}  /> 
            <Answer data={answer} question={question} />
            {data.length - 1 !== index && <p className={Styles.onSelectedtab} style={{ marginBottom:'10px', marginTop:'15px'}}></p>}
            </>
          )
        })}
        {data.length ===0 && 
        <Skeleton active />
        }
    </div>
    </>
  )
}
